import * as React from 'react';
import { Button, Modal, RadioButtonGroup } from '@ixicare/ui';
import { t } from '~/i18n';
import { declineReasons } from '~config/alert';

interface AlertCancelModalProps {
  onClose: () => void;
  onReject: (reason: string) => void;
  loading: boolean;
}

const AlertRejectModal: React.FC<AlertCancelModalProps> = ({ onClose, onReject, loading }) => {
  const [reason, setReason] = React.useState('');
  const handleCancel = React.useCallback(() => {
    onReject(reason);
  }, [reason]);
  return (
    <Modal onClose={onClose} style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-30">{t('alert.decline.title')}</h3>
      <div className="mb-30">
        <RadioButtonGroup
          withOtherOption
          options={declineReasons}
          onChange={setReason}
          value={reason}
          name="cancel-reasons"
        />
      </div>
      <Button className="mt-15 mb-15" loading={loading} disabled={loading} isBlock onClick={handleCancel}>
        {t('alert.decline.submit')}
      </Button>
    </Modal>
  );
};

export default AlertRejectModal;
